import { phoneFormat } from 'util/formatters'
import { SUPPORT_NUMBER } from 'util/support'
import { useTranslation } from 'react-i18next'

const NoProvidersAvailable = () => {
  const { t } = useTranslation()

  const supportLink = (
    <a href={`tel:+${SUPPORT_NUMBER}`} className="text-link-primary font-bold" data-testid="support-phone-number">
      {phoneFormat(SUPPORT_NUMBER)}
    </a>
  )

  return (
    <div className="flex flex-grow flex-col items-center text-center">
      <h3 className="typography-h4 text-neutral py-8 font-normal">{t('visits.noProviders.moreInfoNeeded')}</h3>
      <p className="typography-body-l py-6">
        {t('visits.noProviders.contactSupportPrefix')} {supportLink} {t('visits.noProviders.contactSupportSuffix')}
      </p>
    </div>
  )
}

export default NoProvidersAvailable
